import { Injectable } from '@angular/core';
import { DataAnalyticsTaggingEvent } from '../../features/data-analytics-tagging/data-analytics-tagging.domain';
import {
  GamlAttestationEditSection,
  GamlAttestationEntryPoint,
  GamlAttestationFlowType
} from './gaml-attestation.domain';

@Injectable()
export abstract class GamlAttestationAnalytics {
  GAML_ATTESTATION_BANNER_EVENT: DataAnalyticsTaggingEvent;
  GAML_ATTESTATION_HALT_TRADE_BANNER_EVENT: DataAnalyticsTaggingEvent;

  abstract getGamlAttestationFlowType(entryPoint: GamlAttestationEntryPoint, isGamlEditClicked: boolean): GamlAttestationFlowType;
  abstract getGamlAttestationLoadEvent(flowType: GamlAttestationFlowType): DataAnalyticsTaggingEvent;
  abstract getGamlAttestationSuccessLoadEvent(flowType: GamlAttestationFlowType): DataAnalyticsTaggingEvent;
  abstract getGamlAttestationModalCloseEvent(flowType: GamlAttestationFlowType): DataAnalyticsTaggingEvent;
  abstract getGamlAttestationEditEvent(section: GamlAttestationEditSection): DataAnalyticsTaggingEvent
}
